import { render } from "./explainerVideo.vue?vue&type=template&id=584c8328"
import script from "./explainerVideo.vue?vue&type=script&lang=js"
export * from "./explainerVideo.vue?vue&type=script&lang=js"

import "./explainerVideo.vue?vue&type=style&index=0&id=584c8328&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__